import React, { useState } from "react";

import {
  Avatar,
  Dropdown,
  DropdownItem,
  DropdownList,
  MenuToggle,
} from "@patternfly/react-core";

import UserProfileCard from "./UserProfileCard";

import imgAvatar from "@patternfly/react-core/src/demos/assets/avatarImg.svg";


const UserDropdown = ({
  userProfile,
  systemInfo,
  avatarSrc = imgAvatar,
  items = [],
  logout,
  openAdmin,
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const profileSvg = <svg aria-hidden="true" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36 36">
    <path fill="currentColor" d="M17.7,20.1c-3.5,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4,6.4,2.9,6.4,6.4-2.8,6.4-6.4,6.4Z" />
    <path fill="currentColor" d="M30.6,36c-.4-3.9-1.3-9-2.9-11-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-.6-6.3-.6-6.1.7-6.1.7c-1.2.4-2.4,1.2-3.4,2.6-1.7,1.9-2.6,7.1-3,10.9h25.2Z" />
  </svg>;
  return (
    <Dropdown
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      onSelect={() => setIsOpen(false)}
      popperProps={{
        position: "right",
      }}
      toggle={(toggleRef) => (
        <MenuToggle
          ref={toggleRef}
          isExpanded={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
          icon={
            // <Avatar
            //   src={avatarSrc}
            //   size="sm"
            // />
             <Avatar color="gray" alt="gray avatar" size="sm">
              {profileSvg}
            </Avatar>
          }
        >
          {userProfile.first_name
            ? `${userProfile.first_name} ${userProfile.last_name}`
            : userProfile.username}
        </MenuToggle>
      )}
    >

      <DropdownList>

        <UserProfileCard
          userProfile={userProfile}
          systemInfo={systemInfo}
        />

        {items
          .filter((item) => item.visible !== false)
          .map((item) => (
            <DropdownItem
              key={item.id}
              onClick={item.onClick}
            >
              {item.label}
            </DropdownItem>
          ))}
        {(userProfile.is_superuser || userProfile.is_staff) && openAdmin && (
          <DropdownItem onClick={openAdmin}>
            Admin Panel
          </DropdownItem>
        )}
        {logout && (
          <DropdownItem onClick={logout}>
            Wyloguj
          </DropdownItem>
        )}

      </DropdownList>

    </Dropdown>
  );
};

export default UserDropdown;